import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setCart, saveCart } from "../actions/cartActions";
import { showSuccess } from "../common/iziToast";
import * as Icons from "../common/icons";
import { withTranslation } from 'react-i18next';
import SocialShare from "../components/SocialShare";
import { utils } from "../common/utils";
import ConfirmDialog from "../components/ConfirmDialog";

class CartShareActions extends Component {

    constructor(props) {
        super(props);
        this.state = { showLoadCartConfirmation: false };

        this.loadToMyCart = this.loadToMyCart.bind(this);
        this.onLoadToMyCart = this.onLoadToMyCart.bind(this);
        this.onCancelLoadToMyCart = this.onCancelLoadToMyCart.bind(this);

    }


    loadToMyCart = e => {

        let { t, selectedCart, user } = this.props;
        this.setState({ showLoadCartConfirmation: false });

        this.props.setCart(selectedCart).then((response) => {
            if (user.isAuthenticated === true) {
                this.props.saveCart(this.props.cart);
            }
        }, (error) => {
            console.log(error)
        });

        showSuccess(t("Load to cart"), `${t("Successfuly Loaded")} ${t("your cart!")}`, Icons.CART);

    };

    onLoadToMyCart() {
        this.setState({ showLoadCartConfirmation: true });
    }

    onCancelLoadToMyCart() {
        this.setState({ showLoadCartConfirmation: false });
    }


    render() {
        const { t, selectedCart, settings, user } = this.props;

        return (
            <Fragment>
                <ConfirmDialog title={t("Load to cart")} open={this.state.showLoadCartConfirmation} message={t("Are you sure you want to load the cart(Your current cart will be replaced)?")}
                    yesTitle={t("Yes")} onYes={this.loadToMyCart} onNo={this.onCancelLoadToMyCart} />
                <div className="product-buttons d-flex justify-content-between w-100 align-items-center flex-column flex-md-row">
                    <SocialShare
                        url={`${utils.getWebshopFullUrl(settings)}carts/${selectedCart.url}`}
                        shape="circle"
                        showTitle={true}
                        displayInline={true}
                        supplierName={settings.supplierName}
                        senderName={user.firstName + ' ' + user.lastName}
                        shareTitle={t('Check this amazing cart')}
                    />
                    <button
                        onClick={this.onLoadToMyCart}
                        className="btn btn-outline-success btn-sm ml-2"  >
                        {t("Load to My Cart")}
                    </button>
                </div>
            </Fragment>
        );
    }
}


function mapStateToProps({ settings, user, cart }, ownProps) {
    return { settings, user, cart, ...ownProps };
}


export default withTranslation()(connect(mapStateToProps, { setCart, saveCart })(CartShareActions));
